import { Modal } from "antd";
import { useEffect, useState } from "react";
import { FaExclamationCircle } from "react-icons/fa";
import { GenericBankFeedsButton } from "./GenericBankFeedsButton";

export const RetryableErrorModal = ({
  errorMessage,
  retryCallback,
  setRetryableErrorMessage,
}: {
  errorMessage: string;
  retryCallback: () => void;
  setRetryableErrorMessage: (value: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);

  // Set to open whenever the error message is set.
  useEffect(() => {
    setOpen(errorMessage != "");
  }, [errorMessage]);

  return (
    <Modal
      visible={open}
      width={400}
      bodyStyle={{ height: 400 }}
      footer={null}
      closable={false}
      maskClosable={false}
      zIndex={9999}>
      <div className="pt-4 pr-6 pl-6">
        <div
          className="flex items-center justify-center"
          style={{
            textAlign: "center",
            verticalAlign: "middle",
          }}>
          <FaExclamationCircle
            size={50}
            style={{
              textAlign: "center",
            }}></FaExclamationCircle>
        </div>
        <div className="text-lg font-bold pb-2" style={{ textAlign: "center" }}>
          Something went wrong
        </div>
        <div className="text-sm" style={{ textAlign: "center" }}>
          {errorMessage}
        </div>
      </div>

      {/* Ensure space b/w message and button. */}
      <div
        style={{
          minHeight: 150,
        }}></div>

      <GenericBankFeedsButton
        text="Try again"
        onClick={() => {
          setOpen(false);
          retryCallback();
          setRetryableErrorMessage("");
        }}
        disabled={false}
      />
    </Modal>
  );
};
